export default function createHtmlMarkerClass(google) {
    const OverlayView = google.maps.OverlayView;

    return class HtmlMarker {
        constructor(options) {
            this.position = options.position;
            this.map = options.map;
            this.content = options.content;
            this.onClick = options.onClick;

            this.div = null;

            // create internal overlay AFTER construction
            this.overlay = new OverlayView();

            this.overlay.onAdd = () => {
                this.div = document.createElement('div');
                this.div.className = 'custom-marker';
                this.div.innerHTML = this.content;

                this.div.addEventListener('click', (e) => {
                    e.stopPropagation();
                    this.onClick?.(e, this);
                });

                this.overlay.getPanes().overlayMouseTarget.appendChild(this.div);
            };

            this.overlay.draw = () => {
                if (!this.div) return;

                const projection = this.overlay.getProjection();

                const point = projection.fromLatLngToDivPixel(
                    new google.maps.LatLng(this.position)
                );

                if (point) {
                    this.div.style.left = `${point.x}px`;
                    this.div.style.top = `${point.y}px`;
                }
            };

            this.overlay.onRemove = () => {
                this.div?.remove();
                this.div = null;
            };

            this.overlay.setMap(this.map);
        }

        // optional helper (keeps API similar)
        addListener(event, cb) {
            if (event === 'click') {
                this.onClick = cb;
            }
        }
    };
}